function nav() {
    const burger = document.querySelector('.header__burger');
    const nav = document.querySelector('.nav');
    const navLinks = document.querySelectorAll('.nav__link');

    burger.addEventListener('click', ()=> {
        burger.classList.toggle('active');
        nav.classList.toggle('show');
    });

    navLinks.forEach(el=> {
        el.addEventListener('click', ()=> {
            burger.classList.remove('active');
            nav.classList.remove('show');
        });
    });
}

export default nav;